export default {
    setNewTypingText: (state, text = '') => Object.assign(state.progress, { currentIndex: 0, currentText: text }),
    overwriteProgressText: (state, { currentText }) => Object.assign(state.progress, { currentText, currentIndex: 0 }),
    setFreeTextTyping: (state, isFreeTextTyping) => Object.assign(state, { isFreeTextTyping }),
    incrementTypingIndex: state => Object.assign(state.progress, { currentIndex: state.progress.currentIndex + 1 }),
    setAttemptedKey: (state, attemptedKey) => Object.assign(state, { attemptedKey }),
    resetAttemptedKey: state => Object.assign(state.attemptedKey, { character: '', isCorrect: false })
};
